module.exports = __webpack_public_path__ + "img/campaigns.d1d9e7fb.svg";